import { API_BASE_URL } from "@constants/urls";
import authAxios from "@helpers/lib/axios";
import type { UserInfo } from "@memorang/types";
import { commerceBasePath } from "./constants";
import type { UpdateUserInput } from "./types";

export const fetchUserInfo = async ({
	appId,
}: {
	appId: string;
}): Promise<UserInfo> => {
	const { data } = await authAxios.get(
		`${API_BASE_URL}/${commerceBasePath}/user`,
		{
			params: {
				appId,
			},
		},
	);
	return data.data;
};

export const updateUserInfo = async ({
	userInfo,
}: {
	userInfo: UpdateUserInput;
}): Promise<boolean> => {
	const { data } = await authAxios.post(
		`${API_BASE_URL}/${commerceBasePath}/user`,
		{
			userInfo,
		},
	);
	return data.data;
};
